import { render, staticRenderFns } from "./addGood.vue?vue&type=template&id=7468e3cc&scoped=true&"
import script from "./addGood.vue?vue&type=script&lang=js&"
export * from "./addGood.vue?vue&type=script&lang=js&"
import style0 from "./addGood.vue?vue&type=style&index=0&id=7468e3cc&lang=less&scoped=true&"
import style1 from "./addGood.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7468e3cc",
  null
  
)

export default component.exports